<template>
  <div>
    <div class="weui-cells__title">修改{{type=='main'?"主":"副"}}手机号</div>
    <div class="weui-cells weui-cells_form" style="margin-top: 10px;">
      <div class="weui-cell weui-cell_vcode">
        <div class="weui-cell__hd">
          <label class="weui-label">手机号
          </label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" type="number" v-model="newPhone" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号" style="text-align:right;" />
        </div>
        <div class="weui-cell__ft" @click="getPhoneCaptcha">
          <button class="weui-vcode-btn">{{getPhoneCaptchaLabel}}</button>
        </div>
      </div>
      <div class="weui-cell  weui-cell_access">
        <div class="weui-cell__hd">
          <label class="weui-label">验证码</label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" type="number" v-model="phoneCaptcha" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="点击输入验证码" style="text-align:right;" />
        </div>
      </div>
    </div>

    <div class="warehousing-footer-item save sureinwarehousing" style="flex:2" @click="save">
      <a href="javascript:;">提 交</a>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      type: "",
      platform: "",
      encodeToken: "",
      token: "",
      newPhone: "",
      userInfo: {},
      phoneCaptcha: "",
      getPhoneCaptchaLabel: "获取验证码"
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
    this.platform = this.$route.params.platform;
    this.type = this.$route.params.type;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        that.userInfo = response.data.data;
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    getPhoneCaptcha() {
      if (
        this.userInfo.phoneMain == this.newPhone ||
        this.userInfo.phoneVice == this.newPhone
      ) {
        weui.alert("请输入一个新的手机号码");
      } else {
        if (this.getPhoneCaptchaLabel != "获取验证码") {
          return;
        } else {
          if (!this.newPhone || this.newPhone.length != 11) {
            weui.alert("请输入正确的手机号码");
            return;
          } else {
            let that = this;
            axios
              .get("/api/user/phoneCaptcha/" + this.newPhone)
              .then(res => {
                if (res.data.success) {
                  weui.toast("验证码已发送", 1500);
                  let timeLong = 90;
                  that.getPhoneCaptchaLabel = "还剩 " + timeLong + " s";
                  let times = setInterval(function() {
                    timeLong--;
                    that.getPhoneCaptchaLabel = "还剩 " + timeLong + " s";
                    if (timeLong == 0) {
                      that.getPhoneCaptchaLabel = "获取验证码";
                      clearInterval(times);
                    }
                  }, 1000);
                } else {
                  weui.alert(res.data.message);
                }
              })
              .catch(err => {
                weui.alert("获取验证码失败");
              });
          }
        }
      }
    },
    del() {},
    save() {
      let that = this;
      if (!this.newPhone || this.newPhone.length != 11) {
        weui.topTips("请绑定您正确的手机号", 2000);
        return;
      } else if (!this.phoneCaptcha || this.phoneCaptcha.length != 4) {
        weui.topTips("请输入正确的验证码", 2000);
        return;
      } else {
        let url = "";
        let param = {};
        if (this.type == "main") {
          url = "/api/user/updatePhoneMain";
          param.phoneMain = this.newPhone;
          param.phoneMainCaptcha = this.phoneCaptcha;
        } else {
          url = "/api/user/updatePhoneVice";
          param.phoneVice = this.newPhone;
          param.phoneViceCaptcha = this.phoneCaptcha;
        }

        axios
          .put(url, param)
          .then(res => {
            console.log(res.data);
            if (res.data.success) {
              weui.toast("保存成功", 1000);
              // 跳转回个人中心页面
              that.$router.push("/userInfo/"+this.platform+"/" + that.encodeToken);
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            weui.alert("保存失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item.delete {
  background-color: orangered;
}
.warehousing-footer-item.save {
  background-color: #1aad19;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/PhoneEdit.vue